export const PERSONALISED_MENTEE_EMAILERS_LINKS = [
  {
    href: 'https://app.powerbi.com/groups/abf45e56-b505-427d-a41c-bca58e280fbf/reports/4ff7d904[…]6d703b3/ReportSection98e6945718b479eb82a5?experience=power-bi',
    label: 'Pre-digest',
    dividerRequired: true,
  },
  {
    href: 'https://app.powerbi.com/groups/abf45e56-b505-427d-a41c-bca58e280fbf/reports/4ff7d904[…]6d703b3/ReportSection98e6945718b479eb82a5?experience=power-bi',
    label: 'Post-digest',
    dividerRequired: false,
  },
];
